import * as Styled from "./RoadworkTask.styled"

export function RoadworkTaskSkeleton() {

    return <Styled.RoadworkTaskWrapper >
        <Styled.Skeleton />
    </Styled.RoadworkTaskWrapper>
}
